export const colors = {
  a: "#2196f3",
  b: "#ec407a",
  c: "#ff9800",
  d: "#66bb6a",
  e: "#5c6bc0",
  f: "#ef5350",
  g: "#8d6e63",
  h: "#26a59a",
  i: "#ff9b12",
  j: "#343434",
  k: "#39589e",
  l: "#7886cb",
  m: "#26a59a",
  n: "#6A1B9A",
  o: "#283593",
  p: "#5C6BC0",
  q: "#4db6ab",
  r: "#444444",
  s: "#888888",
  t: "#37474F",
  u: "#4E342E",
  v: "#FF7043",
  w: "#263238",
  x: "#009688",
  y: "#00bcd4",
  z: "#8BC34A"
};

export const dateFormat = "YYYY-MMM-DD";
export const RenderDateForm = "DD MMM, YYYY";